import { useQuery } from '@tanstack/react-query'

type Position = GeoJSON.Position | null

type PlaceType = 'address' | 'neighborhood' | 'postcode' | 'locality' | 'place' | 'district' | 'region' | 'country'

interface Context {
  id: string
  mapbox_id: string
  text: string
  wikidata?: string
  short_code?: string
}

interface Properties {
  accuracy?: string
  mapbox_id: string
  wikidata?: string
  short_code?: string
  context: Context[]
}

interface Feature {
  id: string
  type: 'Feature'
  place_type: PlaceType[]
  relevance: number
  properties: Properties
  text: string
  place_name: string
  center: Position
  geometry: GeoJSON.Geometry
  address?: string
  bbox?: GeoJSON.BBox
}

interface ReverseGeocodeResponse {
  type: 'FeatureCollection'
  query: GeoJSON.Position
  features: Feature[]
}

const reverseGeoCodeQuery = async (position: Position) => {
  const [lon, lat] = position ?? [null, null]

  const res = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`)
  const data: ReverseGeocodeResponse = await res.json()
  const placeName = data.features[0].place_name
  return placeName
}

export const useReverseGeocode = (position: Position) =>
  useQuery({
    queryKey: ['reverseGeocode', position],
    queryFn: async () => reverseGeoCodeQuery(position),
    enabled: Boolean(position?.length)
  })
